import type { QualitySetting, ResolvedQuality } from '../types';

/** Every device starts at high; only an explicit, remembered choice may override it. */
export function readQuality(storage?: Pick<Storage, 'getItem'>): QualitySetting {
  try {
    const value = (storage ?? localStorage).getItem('diceai-space-quality');
    if (value === 'high' || value === 'medium' || value === 'low' || value === 'auto') return value;
  } catch { /* Private browsing can disallow storage. */ }
  return 'high';
}

export function resolveQuality(requested: QualitySetting, cores = navigator.hardwareConcurrency || 4, viewportWidth = window.innerWidth): ResolvedQuality {
  if (requested === 'low' || requested === 'medium' || requested === 'high') return requested;
  if (cores <= 4 || viewportWidth < 720) return 'low';
  return cores >= 8 ? 'high' : 'medium';
}

export function qualityPixelRatio(quality: ResolvedQuality, devicePixelRatio = window.devicePixelRatio || 1): number {
  return Math.min(devicePixelRatio, quality === 'low' ? 1 : quality === 'medium' ? 1.3 : 1.5);
}
